<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add An Agent</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-field label="Name">
        <b-input v-model.trim="name" type="text" placeholder="Enter Name" required></b-input>
      </b-field>
      <b-field label="Mobile Number">
        <b-input v-model.trim="number" type="tel" placeholder="Enter Mobile Number" required></b-input>
      </b-field>
      <b-field label="Email">
        <b-input v-model.trim="email" type="email" placeholder="Enter Agent Email" required></b-input>
      </b-field>
      <b-field label="Max Ticket/Game">
        <b-input v-model.number="limit" type="number" min="1" placeholder="Enter Limit ex. 20" required></b-input>
      </b-field>
      <b-field label="Password">
        <b-input v-model="password" type="password" password-reveal placeholder="Enter Password" required></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button type="button" class="button is-primary" @click="submit()">Add Agent</button>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "CreateAgent",
    data() {
      return {
        name: "",
        number: "",
        email: "",
        limit: 20,
        password: ""
      };
    },
    methods: {
      submit() {
        const problem = this.validate();
        if (problem) {
          return this.$buefy.toast.open({ message: problem, type: "is-danger" });
        }

        this.$emit("AddAgent", {
          name: this.name,
          number: this.number,
          limit: parseInt(this.limit, 10),
          email: this.email.toLowerCase(),
          password: this.password
        });
        this.$parent.close();
      },
      validate() {
        if (!this.name) return "Name is required.";
        if (this.number.length < 10) return "Invalid mobile number!";
        if (!this.email.includes("@")) return "Enter a valid email address.";
        if (!this.limit || this.limit < 1) return "Ticket limit must be at least 1.";
        if (this.password.length < 6) return "Password must be at least 6 characters.";
        return null;
      }
    }
  };
</script>
